"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initBlizzardWebClient = exports.useWebPageOpen = exports.useWebSession = void 0;
var WebSession_1 = require("./WebSession");
Object.defineProperty(exports, "useWebSession", { enumerable: true, get: function () { return WebSession_1.useWebSession; } });
var WebPageOpen_1 = require("./WebPageOpen");
Object.defineProperty(exports, "useWebPageOpen", { enumerable: true, get: function () { return WebPageOpen_1.useWebPageOpen; } });
var blizzard_1 = require("./blizzard");
Object.defineProperty(exports, "initBlizzardWebClient", { enumerable: true, get: function () { return blizzard_1.initBlizzardWebClient; } });
//# sourceMappingURL=index.js.map